import React from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '../ThemeContext';

export default function ThemeToggle() {
  const { isCyberpunk, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className="relative group flex items-center gap-2"
      aria-label="Toggle cyberpunk mode"
    >
      {/* Label */}
      <span
        className={`font-mono text-xs tracking-wider transition-colors duration-500 hidden sm:inline ${
          isCyberpunk ? 'text-cyber-magenta' : 'text-gray-400'
        }`}
      >
        {isCyberpunk ? 'CYBER' : 'CLEAN'}
      </span>

      {/* Toggle track */}
      <div
        className={`relative w-14 h-7 rounded-sm border transition-all duration-500 ${
          isCyberpunk
            ? 'border-cyber-magenta/60 bg-cyber-magenta/10 shadow-[0_0_15px_rgba(255,0,255,0.3)]'
            : 'border-gray-600 bg-gray-800'
        }`}
      >
        {/* Cyber grid lines inside track */}
        {isCyberpunk && (
          <>
            <div className="absolute inset-0 opacity-30">
              <div className="absolute top-1/2 left-0 right-0 h-[1px] bg-cyber-magenta/30" />
              <div className="absolute left-1/3 top-0 bottom-0 w-[1px] bg-cyber-magenta/20" />
              <div className="absolute left-2/3 top-0 bottom-0 w-[1px] bg-cyber-magenta/20" />
            </div>
          </>
        )}

        {/* Toggle knob */}
        <motion.div
          layout
          transition={{ type: 'spring', stiffness: 500, damping: 30 }}
          className={`absolute top-[3px] w-5 h-5 flex items-center justify-center transition-colors duration-500 ${
            isCyberpunk
              ? 'left-[calc(100%-23px)] bg-cyber-magenta shadow-[0_0_10px_#ff00ff]'
              : 'left-[3px] bg-gray-400'
          }`}
        >
          {/* Power icon inside knob */}
          <svg
            width="10"
            height="10"
            viewBox="0 0 24 24"
            fill="none"
            stroke={isCyberpunk ? '#0a0a0f' : '#1a1a2e'}
            strokeWidth="3"
            strokeLinecap="round"
          >
            <line x1="12" y1="2" x2="12" y2="10" />
            <path d="M16.24 7.76a6 6 0 1 1-8.49 0" />
          </svg>
        </motion.div>
      </div>
    </button>
  );
}
